import React from 'react';

export default function LocaleDateTime({ isoInstant }) {
  // Strictly speaking, this doesn't need to be a fragment, but it costs nothing
  // and it silences an IntelliJ/lint warning.
  return <>{isoInstant ? new Date(isoInstant).toLocaleString() : '(none)'}</>;
}
